import React from 'react';

import { data } from 'services';
import { Wrapper, Description, MainInfo, Label, Property, AdditionalInfo, CloseButton, Scroller } from 'libs/ui';
import { getDateTime, getRackName } from 'services/types';
import { useTranslation } from 'react-i18next';

const InfoBlock = (props) => {
  const { info } = props;

  const { t } = useTranslation();
  //console.log('🚀 ~ InfoBlock ~ info', info);

  if (!info) {
    return null;
  }

  return (
    <Wrapper>
      <Description>
        {info.message ? info.message : ''}
        <CloseButton onClick={props.close} />
      </Description>
      <Scroller>
        <MainInfo>
          <Property>
            <Label>{t('grid.Время')}</Label>
            <span>{getDateTime(info.timestamp)}</span>
          </Property>
          <Property>
            <Label>{t('grid.Источник')}</Label>
            <span>{data.getDictValue('rack_type', info.source_type)}</span>
          </Property>
          <Property>
            <Label>№</Label>
            <span>{getRackName(info.source)}</span>
          </Property>
          <Property>
            <Label>{t('grid.Приоритет')}</Label>
            <span>{data.getDictValue('events.type', info.type)}</span>
          </Property>
        </MainInfo>
        <AdditionalInfo>
          <Label>{t('grid.Дополнительно')}</Label>
          <pre>
            <br />
            {JSON.stringify(info, null, 2)}
          </pre>
        </AdditionalInfo>
      </Scroller>
    </Wrapper>
  );
};

export default InfoBlock;
